import React, { useState } from 'react';
import Select, { components } from 'react-select';

const { ValueContainer, Placeholder } = components;

const CustomValueContainer = ({ children, ...props }) => {
  return (
    <ValueContainer {...props}>
      <Placeholder {...props} isFocused={props.isFocused}>
        {props.selectProps.placeholder}
      </Placeholder>
      {React.Children.map(children, child =>
        child && child.type !== Placeholder ? child : null
      )}
    </ValueContainer>
  );
};

const ListGridView = ({customerDetails,documentList}) => {

  const [selectedDocId, setSelectedDocId] = useState(null);
  const [currentSlide, setCurrentSlide] = useState(0);



  const categoryOptions = documentList.map(doc => ({
    value: doc.id,
    label: doc.name
  }));


  const filteredSurveyDocs = selectedDocId
  ? customerDetails?.surveys?.[0]?.survey_docs.filter(doc => doc.doc_id === selectedDocId)
  : [];

  const showSlider = filteredSurveyDocs; // array

  const goToPrevSlide = () => {
    setCurrentSlide(prev =>
      prev === 0 ? showSlider.length - 1 : prev - 1
    );
  };
  
  const goToNextSlide = () => {
    setCurrentSlide(prev =>
      prev === showSlider.length - 1 ? 0 : prev + 1
    );
  };
  
  console.log("**************",showSlider[currentSlide])
  return (
    <div className="doument-view-list-gallery">
      <div className="file-submit-sec list-view">
        <div className="file-submit-selet-list">
          <fieldset className="single-select">
            <div className="material">
              <Select
                components={{ ValueContainer: CustomValueContainer }}
                options={categoryOptions}
                placeholder="Category"
                className="react-select"
                classNamePrefix="react-select"
                onChange={(selected) => setSelectedDocId(selected?.value)}
              />
            </div>
          </fieldset>
        </div>

        <div className="doc-count">
          Photos <span>{categoryOptions.findIndex(cat=> cat.value === selectedDocId) + 1}/{categoryOptions?.length}</span>
        </div>

        <div className="verfication-img">
        {(filteredSurveyDocs.length === 0 && !selectedDocId) && (
            <p>Select Photos From Dropdown</p>
        )}
        {(filteredSurveyDocs.length === 0 && selectedDocId) && (
            <p>No Image Found</p>
        )}
        {/* {filteredSurveyDocs.map(item => (
            <img
            key={item.id}
            src={item.doc_path}
            alt="uploaded"
            className="uploaded-image"
            />
        ))} */}

        {showSlider?.length > 0 && (
        <img
            src={showSlider[currentSlide]?.doc_path_watermark || showSlider[currentSlide]?.doc_path}
            alt="document"
        />
        )}
        </div>
        {showSlider && showSlider.length > 1 ? (
        <div className="image-opt-fci">
            <ul>
            <li className="icn-pre-slide">
                <button onClick={goToPrevSlide}>
                <i className="ic-keyboard_arrow_left"></i>
                </button>
            </li>
            <li className="icn-next-slide">
                <button onClick={goToNextSlide}>
                <i className="ic-keyboard_arrow_right"></i>
                </button>
            </li>
            </ul>
        </div>
        ) : null}
      </div>
    </div>
  );
};

export default ListGridView;
